import React from "react";

/**
 * One-shot notice after refresh/login when AI credits were topped up.
 *
 * Visibility is controlled by the parent so list notices can share a single
 * priority slot (usage limit > catch-up > aging > credits restored).
 *
 * @example
 * <AiCreditsToppedUpBanner visible onDismiss={() => {}} />
 */
const AiCreditsToppedUpBanner = ({ visible = false, onDismiss }) => {
  if (!visible) return null;

  return (
    <div
      className="action-items-catch-up-banner action-items-catch-up-banner--credits-restored"
      role="status"
      aria-live="polite"
    >
      <p className="action-items-catch-up-banner__text">
        <span className="action-items-catch-up-banner__segment">
          Your AI credits have been topped up
          <span className="action-items-catch-up-banner__suffix">
            — you can use AI features again
          </span>
        </span>
      </p>
      <button
        type="button"
        className="action-items-catch-up-banner__close"
        onClick={onDismiss}
        aria-label="Dismiss"
        title="Dismiss"
      >
        ×
      </button>
    </div>
  );
};

export default AiCreditsToppedUpBanner;
